__turbopack_context__.v({
  "more": "index-module__uc8_RG__more",
  "slide": "index-module__uc8_RG__slide",
  "title": "index-module__uc8_RG__title",
  "wrapper": "index-module__uc8_RG__wrapper",
});
